"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actor_abstract_path_1 = require("@comunica/actor-abstract-path");

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var rdf_string_1 = require("rdf-string");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A comunica Path ZeroOrMore Query Operation Actor.
 */


var ActorQueryOperationPathZeroOrMore =
/*#__PURE__*/
function (_actor_abstract_path_) {
  _inherits(ActorQueryOperationPathZeroOrMore, _actor_abstract_path_);

  function ActorQueryOperationPathZeroOrMore(args) {
    _classCallCheck(this, ActorQueryOperationPathZeroOrMore);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationPathZeroOrMore).call(this, args, sparqlalgebrajs_1.Algebra.types.ZERO_OR_MORE_PATH));
  }

  _createClass(ActorQueryOperationPathZeroOrMore, [{
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(path, context) {
        var predicate, sVar, oVar, bindingsStream, v, pred, _bindingsStream;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                predicate = path.predicate;
                sVar = path.subject.termType === 'Variable';
                oVar = path.object.termType === 'Variable';

                if (!(sVar && oVar)) {
                  _context.next = 7;
                  break;
                }

                throw new Error('ZeroOrMore path expressions with 2 variables not supported yet');

              case 7:
                if (!(!sVar && !oVar)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 10;
                return this.ALPeval(path.subject, predicate.path, context);

              case 10:
                _context.t0 = {
                  filter: function filter(item) {
                    return item.equals(path.object);
                  },
                  transform: function transform(item, next) {
                    bindingsStream._push(bus_query_operation_1.Bindings({}));

                    next(null);
                  }
                };
                bindingsStream = _context.sent.transform(_context.t0);
                return _context.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  variables: []
                });

              case 15:
                // if (sVar || oVar)
                v = rdf_string_1.termToString(sVar ? path.subject : path.object);
                pred = sVar ? actor_abstract_path_1.ActorAbstractPath.FACTORY.createInv(predicate.path) : predicate.path;
                _context.next = 19;
                return this.ALPeval(sVar ? path.object : path.subject, pred, context);

              case 19:
                _context.t1 = {
                  transform: function transform(item, next) {
                    _bindingsStream._push(bus_query_operation_1.Bindings(_defineProperty({}, v, item)));

                    next(null);
                  }
                };
                _bindingsStream = _context.sent.transform(_context.t1);
                return _context.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: _bindingsStream,
                  variables: [v]
                });

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function runOperation(_x, _x2) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationPathZeroOrMore;
}(actor_abstract_path_1.ActorAbstractPath);

exports.ActorQueryOperationPathZeroOrMore = ActorQueryOperationPathZeroOrMore;